import { createFileRoute, redirect } from '@tanstack/react-router';
import type { Practitioner } from '@medplum/fhirtypes';

import { medplum } from '@/config/medplum';
import { queryClient } from '@/config/queryClient';
import { getUserPermissions } from '@/lib/auth/permissions';
import { getAuthUserQueryKey, fetchAuthUser } from '@/features/practitioners/hooks/useMedplumAuth';

export const Route = createFileRoute('/(authenticated)')({
	beforeLoad: async () => {
		const activeLogin = medplum.getActiveLogin();

		if (!activeLogin) {
			throw redirect({
				to: '/',
			});
		}

		if (!medplum.getProfile()) {
			await medplum.getProfileAsync();
		}

		const { permissions } = await getUserPermissions();
		if (permissions.length === 0) {
			await medplum.signOut();
			queryClient.clear();
			throw redirect({ to: '/', search: { error: 'unauthorized' } });
		}

		const profile = medplum.getProfile();
		if (profile?.resourceType === 'Practitioner') {
			await queryClient.ensureQueryData({
				queryKey: getAuthUserQueryKey(profile),
				queryFn: () => fetchAuthUser(medplum, profile as Practitioner),
				staleTime: Number.POSITIVE_INFINITY,
			});
		}
	},
});
